import {ZendeskCategory, ZendeskCategoryName} from '../zendesk/zendesk.enums';

interface CategoryArticle extends Article {
  slug: string;
  order: number;
  status: number;
  hidden: boolean;
}

interface Article {
  id: string;
  title: string;
}

interface VideoTutorialData extends Article {
  youtubeVideoId: string;
}

interface KnowledgeCenterData extends Article {
  icon?: string;
  childCategories: ChildCategory[];
  articles: KnowledgeCenterArticle[];
}

interface ChildCategory extends Article {
  order: number;
  articles: KnowledgeCenterArticle[];
}
interface KnowledgeCenterArticle extends Article {
  color?: string;
  articles?: KnowledgeCenterArticle[];
  childCategories?: KnowledgeCenterData[];
}

interface HelpArticle {
  title: string;
  htmlContent: string;
}

type ZendeskCategoryConfigItem = {
  category: ZendeskCategory;
  name: ZendeskCategoryName;
  tab: KnowledgeCenterTab;
};

enum KnowledgeCenterTab {
  ProductDocs = 'product-docs',
  AgencyDocs = 'agency-docs',
  StrategyDocs = 'strategy-docs',
  ReleaseNotes = 'release-notes',
  ExternalApi = 'public-api',
  BestPractices = 'best-practices',
  Videos = 'videos',
}

export {
  Article,
  HelpArticle,
  CategoryArticle,
  VideoTutorialData,
  KnowledgeCenterData,
  KnowledgeCenterArticle,
  KnowledgeCenterTab,
  ZendeskCategoryConfigItem,
};
